import Enums from '@core/types/api/Enums';

export const getPermissionLabel = (permission: Enums.Permission): string => {
  const labels: Record<Enums.Permission, string> = {
    [Enums.Permission.ViewCostData]: 'Cost Data',
    [Enums.Permission.ViewMaterialsSection]: 'Materials',
    [Enums.Permission.ViewMixDesignsSection]: 'Mix Designs',
    [Enums.Permission.ViewActualsDashboard]: 'Backlog',
    [Enums.Permission.ViewTruckingType]: 'Trucking Type',
    [Enums.Permission.CanBulkEditQuotes]: 'Bulk Edit Quotes',
    [Enums.Permission.CanBulkEditProjects]: 'Bulk Edit Projects',
    [Enums.Permission.CanBulkEditCompanies]: 'Bulk Edit Companies',
    [Enums.Permission.CanBulkEditLocations]: 'Bulk Edit Locations',
    [Enums.Permission.CanBulkEditActivities]: 'Bulk Edit Activities',
    [Enums.Permission.CanViewSensitiveFiles]: 'Sensitive Files',
    [Enums.Permission.CanEditAllActivities]: 'Edit All Activities',
    [Enums.Permission.CanViewPlanning]: 'View Planning',
    [Enums.Permission.CanEditPlanning]: 'Edit Planning',
    [Enums.Permission.CanApprovePlanning]: 'Approve Planning',
  };

  return labels[permission];
};
